import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from './pages/Dashboard';
import Model from "./pages/Model";
import Start from "./pages/Start";
import MissionsDashboard from "./pages/MissionsDashboard";
import Wizard from "./pages/Wizard";
import NotFound from './pages/NotFound';
import Metrics from './pages/OverallMetrics';
import Mission from "./pages/Mission";
import User from "./pages/User";
import Annotation from "./pages/Annotation";
import Config from "./pages/Config";
import Feedback from "./pages/Feedback";
import insightService from "./insight-service"

Vue.use(Router);

const path = '/nuxeo/ai';

export default new Router({
    base: path,
    routes: [
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
        {
            path: '/missions',
            name: 'missions',
            component: MissionsDashboard,
            beforeEnter: (to, from, next) => {
                restrictToLibrarian(from, next);
            },
        },
        {
            path: '/model/:id',
            name: 'model',
            component: Model,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
        {
            path: '/mission/:id',
            name: 'mission',
            component: Mission
        },
        {
            path: '/annotation/:id',
            name: 'annotation',
            component: Annotation
        },
        {
            path: '/',
            name: 'start',
            component: Start,
        },
        {
            path: '/user/:id',
            name: 'user',
            component: User,
            beforeEnter: (to, from, next) => {
                if (insightService.isManager()) {
                    next()
                } else {
                    if (insightService.getId() === to.params.id) {
                        next()
                    } else {
                        next({name: 'start'});
                    }
                }
            },
        },
        {
            path: '/',
            name: 'onboarding',
            component: Start,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
        {
            path: '/',
            name: 'feedback',
            component: Feedback
        },
        {
            path: '/!',
            name: 'start',
            component: Start
        },
        {
            path: '/wizard',
            name: 'wizard',
            component: Wizard,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
        {
            path: '*',
            name: 'notfound',
            component: NotFound
        },
        {
            path: '/noauth',
            name: 'noauth',
            component: NotFound
        },
        {
            path: '/metrics',
            name: 'metrics',
            component: Metrics,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
        {
            path: '/config',
            name: 'config',
            component: Config,
            beforeEnter: (to, from, next) => {
                restrictToManager(from, next);
            },
        },
    ]
})

const restrictToManager = (from, next) => {
    if (insightService.isManager()) {
        next()
    } else {
        return from
    }
}

const restrictToLibrarian = (from, next) => {
    if (!insightService.isManager()) {
        next()
    } else {
        return from
    }
}
